module.exports = __webpack_public_path__ + "static/media/CVOUBDABOKOLAALASSANEF.df312994.pdf";